import React, { useEffect, useState } from "react";

import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RecoilRoot, atom } from "recoil";
import styled from "styled-components";
import { Brackets } from "./Brackets";
import { Header } from "./Header";
import { AddPlayers } from "./pages/AddPlayers";
import { Scores } from "./pages/Scores";
import { Team } from "./pages/Team";
import { useScores } from "./hooks/useScores";

export const playerTeams = atom({
  key: "playerTeams",
  default: {
    cbd: [],
    gla: [],
    pen: [],
    hur: [],
  },
});

const Loading = styled.div``;

const App = () => {
  const [canShow, setCanShow] = useState(true);

  useEffect(() => {
    window.setTimeout(() => {
      setCanShow(true);
    }, 4000);
  }, []);

  const { data: scoreData, bracketPoints } = useScores();
  // console.log("🚨", scoreData);

  return (
    <RecoilRoot>
      <BrowserRouter>
        {canShow ? (
          <Loading>
            <Header />
            <Switch>
              <Route
                path="/"
                exact
                render={() => (
                  <Scores scores={scoreData} bracketPoints={bracketPoints} />
                )}
              />
              <Route path="/setrosters" exact component={AddPlayers} />
              <Route path="/brackets" exact component={Brackets} />
              <Route
                path="/cbd"
                exact
                render={() => <Team scores={scoreData} team="cbd" />}
              />
              <Route
                path="/pen"
                exact
                render={() => <Team scores={scoreData} team="pen" />}
              />
              <Route
                path="/gla"
                exact
                render={() => <Team scores={scoreData} team="gla" />}
              />
              <Route
                path="/hur"
                exact
                render={() => <Team scores={scoreData} team="hur" />}
              />
              {/* <Route path="/config" exact component={ConfigureApp} /> */}
            </Switch>
          </Loading>
        ) : (
          <h1>LOADING</h1>
        )}
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
